<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Romans</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="abb"><a id="page_vi"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<p class="H1a">PERIODICALS, REFERENCE WORKS, AND SERIALS</p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr><td>AB</td><td>Anchor Bible</td></tr>
<tr><td><i>ABD</i></td><td>D. N. Freedman (ed.), <i>Anchor Bible Dictionary</i></td></tr>
<tr><td>ABRL</td><td>Anchor Bible Reference Library</td></tr>
<tr><td>ADPV</td><td>Abhandlungen des deutschen Palästina-Vereins</td></tr>
<tr><td>AGJU</td><td>Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</td></tr>
<tr><td><i>AJA</i></td><td><i>American Journal of Archaeology</i></td></tr>
<tr><td><i>AJBI</i></td><td><i>Annual of the Japanese Biblical Institute</i></td></tr>
<tr><td><i>AJP</i></td><td><i>American Journal of Philology</i></td></tr>
<tr><td><i>AJT</i></td><td><i>American Journal of Theology</i></td></tr>
<tr><td>AnBib</td><td>Analecta biblica</td></tr>
<tr><td><i>ANEP</i></td><td>J. B. Pritchard (ed.), <i>Ancient Near East in Pictures</i></td></tr>
<tr><td><i>ANET</i></td><td>J. B. Pritchard (ed.), <i>Ancient Near Eastern Texts</i></td></tr>
<tr><td><i>ANRW</i></td><td><i>Aufstieg und Niedergang der römischen Welt</i></td></tr>
<tr><td>ANTC</td><td>Abingdon New Testament Commentary</td></tr>
<tr><td>AOAT</td><td>Alter Orient und Altes Testament</td></tr>
<tr><td><i>APOT</i></td><td>R. H. Charles (ed.), <i>Apocrypha and Pseudepigrapha of the Old Testament</i></td></tr>
<tr><td>ASV</td><td>American Standard Version</td></tr>
<tr><td>ATANT</td><td>Abhandlungen zur Theologie des Alten und Neuen Testaments</td></tr>
<tr><td>ATD</td><td>Das Alte Testament Deutsch</td></tr>
<tr><td>ATDA</td><td>Das Alte Testament Deutsch Apokryphen</td></tr>
<tr><td>ATLAMS</td><td>American Theological Library Association Monograph Series</td></tr>
<tr><td><i>ATR</i></td><td><i>Anglican Theological Review</i></td></tr>
<tr><td><i>AusBR</i></td><td><i>Australian Biblical Review</i></td></tr>
<tr><td>AV</td><td>Authorized Version</td></tr>
<tr><td><i>BA</i></td><td><i>Biblical Archaeologist</i></td></tr>
<tr><td>BAGD</td><td>W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, <i>Greek-English Lexicon of the New Testament</i></td></tr>
<tr><td><i>BAR</i></td><td><i>Biblical Archaeology Review</i></td></tr>
<tr><td><i>BASOR</i></td><td><i>Bulletin of the American Schools of Oriental Research</i></td></tr>
<tr><td>BBB</td><td>Bonner biblische Beiträge</td></tr>
<tr><td><i>BBR</i></td><td>Bulletin for Biblical Research</td></tr>
<tr><td>BDB</td><td>F. Brown, S. R. Driver, and C. A. Briggs, <i>Hebrew and English Lexicon of the Old Testament</i></td></tr>
<tr><td>BETL</td><td>Bibliotheca ephemeridum theologicarum lovaniensium</td></tr>
<tr><td><i>BHS</i></td><td><i>Biblia hebraica stuttgartensia</i></td></tr>
<tr><td><i>Bib</i></td><td><i>Biblica</i></td></tr>
<tr><td><i>BibRev</i></td><td><i>Bible Review</i></td></tr>
<tr><td><i>BJRL</i></td><td><i>Bulletin of the John Rylands University Library of Manchester</i></td></tr>
<tr><td>BJS</td><td>Brown Judaic Studies</td></tr>
<tr><td>BKAT</td><td>Biblischer Kommentar: Altes Testament</td></tr>
<tr><td>BNTC</td><td>Black New Testament Commentary</td></tr>
<tr><td><i>BR</i></td><td><i>Biblical Research</i></td></tr>
<tr><td><i>BT</i></td><td><i>The Bible Translator</i></td></tr>
<tr><td><i>BTB</i></td><td><i>Biblical Theology Bulletin</i></td></tr>
<tr><td>BWANT</td><td>Beiträge zur Wissenschaft vom Alten und Neuen Testament</td></tr>
<tr><td><i>BZ</i></td><td><i>Biblische Zeitschrift</i></td></tr>
<tr><td>BZAW</td><td>Beihefte zur <i>ZAW</i></td></tr>
<tr><td>BZNW</td><td>Beihefte zur <i>ZNW</i></td></tr>
<tr><td>CBC</td><td>Cambridge Bible Commentary</td></tr>
<tr><td><i>CBQ</i></td><td><i>Catholic Biblical Quarterly</i></td></tr>
<tr><td>CBQMS</td><td>Catholic Biblical Quarterly—Monograph Series</td></tr>
<tr><td>CBSC</td><td>Cambridge Bible for Schools and Colleges</td></tr>
<tr><td><i>CIG</i></td><td><i>Corpus inscriptionum graecarum</i></td></tr>
<tr><td>CNT</td><td>Commentaire du Nouveau Testament</td></tr>
<tr><td>ConBNT</td><td>Coniectanea biblica, New Testament</td></tr>
<tr><td>ConBOT</td><td>Coniectanea biblica, Old Testament</td></tr>
<tr><td><i>CP</i></td><td><i>Classical Philology</i></td></tr>
<tr><td><i>CPJ</i></td><td><i>Corpus Papyrorum Judaicarum</i></td></tr>
<tr><td><i>CR:BS</i></td><td><i>Currents in Research: Biblical Studies</i></td></tr>
<tr><td>CRINT</td><td>Compendia rerum iudaicarum ad novum testamentum</td></tr>
<tr><td>DJD</td><td>Discoveries in the Judaean Desert</td></tr>
<tr><td><i>DLNTD</i></td><td><i>Dictionary of the Later New Testament and Its Developments</i></td></tr>
<tr><td><i>DOTT</i></td><td>D. W. Thomas (ed.), <i>Documents from Old Testament Times</i></td></tr>
<tr><td><i>DPL</i></td><td><i>Dictionary of Paul and His Letters</i></td></tr>
<tr><td>Ebib</td><td>Etudes bibliques</td></tr>
<tr><td><i>EDNT</i></td><td><i>Exegetical Dictionary of the New Testament</i></td></tr>
<tr><td>EKKNT</td><td>Evangelisch-katholischer Kommentar zum Neuen Testament</td></tr>
<tr><td>ErIsr</td><td>Eretz Israel</td></tr>
<tr><td><i>EstBíb</i></td><td><i>Estudios bíblicos</i></td></tr>
<tr><td>ESV</td><td>English Standard Version</td></tr>
<tr><td><i>ETL</i></td><td><i>Ephemerides theologicae lovanienses</i></td></tr>
<tr><td><i>EvQ</i></td><td><i>Evangelical Quarterly</i></td></tr>
<tr><td><i>EvT</i></td><td><i>Evangelische Theologie</i></td></tr>
<tr><td><i>ExpTim</i></td><td><i>Expository Times</i></td></tr>
<tr><td>FAT</td><td>Forschungen zur Altes Testament</td></tr>
<tr><td>FOTL</td><td>Forms of the Old Testament Literature</td></tr>
<tr><td><a id="page_vii">FRLANT</a></td><td>Forschungen zur Religion und Literatur des Alten und Neuen Testaments</td></tr>
<tr><td>GNB</td><td>Good News Bible</td></tr>
<tr><td>GNS</td><td>Good New Studies</td></tr>
<tr><td><i>HAR</i></td><td><i>Hebrew Annual Review</i></td></tr>
<tr><td>HAT</td><td>Handbuch zum Alten Testament</td></tr>
<tr><td><i>HBT</i></td><td><i>Horizons in Biblical Theology</i></td></tr>
<tr><td>HDR</td><td>Harvard Dissertations in Religion</td></tr>
<tr><td><i>HeyJ</i></td><td><i>Heythrop Journal</i></td></tr>
<tr><td>HNT</td><td>Handbuch zum Neuen Testament</td></tr>
<tr><td>HNTC</td><td>Harper’s New Testament Commentaries</td></tr>
<tr><td><i>HR</i></td><td><i>History of Religions</i></td></tr>
<tr><td>HSM</td><td>Harvard Semitic Monographs</td></tr>
<tr><td>HSS</td><td>Harvard Semitic Studies</td></tr>
<tr><td>HTKNT</td><td>Herders theologischer Kommentar zum Neuen Testament</td></tr>
<tr><td><i>HTR</i></td><td><i>Harvard Theological Review</i></td></tr>
<tr><td>HTS</td><td>Harvard Theological Studies</td></tr>
<tr><td>HUT</td><td>Hermeneutische Untersuchungen zur Theologie</td></tr>
<tr><td><i>IB</i></td><td><i>Interpreter’s Bible</i></td></tr>
<tr><td>IBC</td><td>Interpretation: A Bible Commentary for Teaching and Preaching</td></tr>
<tr><td><i>IBS</i></td><td><i>Irish Biblical Studies</i></td></tr>
<tr><td>ICC</td><td>International Critical Commentary</td></tr>
<tr><td><i>IDB</i></td><td>G. A. Buttrick (ed.), <i>Interpreter’s Dictionary of the Bible</i></td></tr>
<tr><td><i>IDBSup</i></td><td>Supplementary volume to <i>IDB</i></td></tr>
<tr><td><i>IEJ</i></td><td><i>Israel Exploration Journal</i></td></tr>
<tr><td><i>Int</i></td><td><i>Interpretation</i></td></tr>
<tr><td>ITC</td><td>International Theological Commentary</td></tr>
<tr><td><i>ITQ</i></td><td><i>Irish Theological Quarterly</i></td></tr>
<tr><td>JAC</td><td>Jahrbuch für Antike und Christentum</td></tr>
<tr><td><i>JANESCU</i></td><td><i>Journal of the Ancient Near Eastern Society of Columbia University</i></td></tr>
<tr><td><i>JAOS</i></td><td><i>Journal of the American Oriental Society</i></td></tr>
<tr><td>JB</td><td>A. Jones (ed.), <i>Jerusalem Bible</i></td></tr>
<tr><td><i>JBC</i></td><td>R. E. Brown et al. (eds.), <i>The Jerome Biblical Commentary</i></td></tr>
<tr><td><i>JBL</i></td><td><i>Journal of Biblical Literature</i></td></tr>
<tr><td><i>JEA</i></td><td><i>Journal of Egyptian Archaeology</i></td></tr>
<tr><td><i>JETS</i></td><td><i>Journal of the Evangelical Theological Society</i></td></tr>
<tr><td><i>JIGRE</i></td><td><i>Jewish Inscriptions in Greco-Roman Egypt</i></td></tr>
<tr><td><i>JJS</i></td><td><i>Journal of Jewish Studies</i></td></tr>
<tr><td><i>JNES</i></td><td><i>Journal of Near Eastern Studies</i></td></tr>
<tr><td><i>JOTTL</i></td><td><i>Journal of Translation and Textlinguistics</i></td></tr>
<tr><td>JPS</td><td>Jewish Publication Society</td></tr>
<tr><td><i>JR</i></td><td><i>Journal of Religion</i></td></tr>
<tr><td>JSHRZ</td><td>Jüdische Schriften aus hellenistischrömischer Zeit</td></tr>
<tr><td><i>JSJ</i></td><td><i>Journal for the Study of Judaism in the Persian, Hellenistic, and Roman Period</i></td></tr>
<tr><td>JSJSup</td><td>Journal for the Study of Judaism Supplement Series</td></tr>
<tr><td><i>JSNT</i></td><td><i>Journal for the Study of the New Testament</i></td></tr>
<tr><td>JSNTSup</td><td>Journal for the Study of the New Testament—Supplement Series</td></tr>
<tr><td><i>JSOT</i></td><td><i>Journal for the Study of the Old Testament</i></td></tr>
<tr><td>JSOTSup</td><td>Journal for the Study of the Old Testament—Supplement Series</td></tr>
<tr><td><i>JSP</i></td><td><i>Journal for the Study of the Pseudepigrapha</i></td></tr>
<tr><td><i>JSS</i></td><td><i>Journal of Semitic Studies</i></td></tr>
<tr><td><i>JTC</i></td><td><i>Journal for Theology and the Church</i></td></tr>
<tr><td><i>JTS</i></td><td><i>Journal of Theological Studies</i></td></tr>
<tr><td>KAT</td><td>Kommentar zum Alten Testament</td></tr>
<tr><td>KJV</td><td>King James Version</td></tr>
<tr><td><i>KS</i></td><td><i>Kirjath-Sepher</i></td></tr>
<tr><td>LCC</td><td>Library of Christian Classics</td></tr>
<tr><td>LEC</td><td>Library of Early Christianity</td></tr>
<tr><td>MNTC</td><td>Moffatt New Testament Commentary</td></tr>
<tr><td>NAB</td><td>New American Bible</td></tr>
<tr><td>NAC</td><td>New American Commentary</td></tr>
<tr><td>NASB</td><td>New American Standard Bible</td></tr>
<tr><td>NABRNT</td><td>New American Bible with Revised Standard Version</td></tr>
<tr><td>NCB</td><td>New Century Bible</td></tr>
<tr><td>NCBC</td><td>New Century Bible Commentary</td></tr>
<tr><td>NEB</td><td>New English Bible</td></tr>
<tr><td><i>Neot</i></td><td><i>Neotestamentica</i></td></tr>
<tr><td>NIBC</td><td>New International Biblical Commentary</td></tr>
<tr><td>NICNT</td><td>New International Commentary on the New Testament</td></tr>
<tr><td>NICOT</td><td>New International Commentary on the Old Testament</td></tr>
<tr><td><i>NIDNTT</i></td><td><i>New International Dictionary of New Testament Theology</i></td></tr>
<tr><td><i>NIDOTTE</i></td><td><i>New International Dictionary of Old Testament Theology and Exegesis</i></td></tr>
<tr><td>NIGTC</td><td>The New International Greek Testament Commentary</td></tr>
<tr><td>NIV</td><td>New International Version</td></tr>
<tr><td>NIVAC</td><td>New International Version Application Commentary</td></tr>
<tr><td>NJB</td><td>H. Wansbrough (ed.), <i>New Jerusalem Bible</i></td></tr>
<tr><td><i>NJBC</i></td><td>R. E. Brown et al. (ed.), <i>The New Jerome Biblical Commentary</i></td></tr>
<tr><td>NJPS</td><td>New Jewish Publication Society</td></tr>
<tr><td><i>NovT</i></td><td><i>Novum Testamentum</i></td></tr>
<tr><td>NovTSup</td><td>Novum Testamentum, Supplements</td></tr>
<tr><td>NRSV</td><td>New Revised Standard Version</td></tr>
<tr><td>NTD</td><td>Das Neue Testament Deutsch</td></tr>
<tr><td>NTG</td><td>New Testament Guides</td></tr>
<tr><td>NTM</td><td>Norsk tidsskrift for misjon</td></tr>
<tr><td><i>NTS</i></td><td><i>New Testament Studies</i></td></tr>
<tr><td>NTSup</td><td>New Testament Supplements</td></tr>
<tr><td>OBO</td><td>Orbis biblicus et orientalis</td></tr>
<tr><td>OBT</td><td>Overtures to Biblical Theology</td></tr>
<tr><td>ÖTKNT</td><td>Ökumenischer Taschenbuchkommentar zum Neuen Testament</td></tr>
<tr><td>OTL</td><td>Old Testament Library</td></tr>
<tr><td><i>OTP</i></td><td>J. H. Charlesworth (ed.), <i>The Old Testament Pseudepigrapha</i></td></tr>
<tr><td><i>PEQ</i></td><td><i>Palestine Exploration Quarterly</i></td></tr>
<tr><td>PNTC</td><td>Pillar New Testament Commentary</td></tr>
<tr><td>QD</td><td>Quaestiones disputatae</td></tr>
<tr><td>QL</td><td>Qumran Literature</td></tr>
<tr><td><i>RB</i></td><td><i>Revue biblique</i></td></tr>
<tr><td><a id="page_viii">REB</a></td><td>Revised English Bible</td></tr>
<tr><td><i>RelSRev</i></td><td><i>Religious Studies Review</i></td></tr>
<tr><td><i>ResQ</i></td><td><i>Restoration Quarterly</i></td></tr>
<tr><td><i>RevQ</i></td><td><i>Revue de Qumran</i></td></tr>
<tr><td>RNT</td><td>Regensburger Neues Testament</td></tr>
<tr><td>RSV</td><td>Revised Standard Version</td></tr>
<tr><td><i>RTP</i></td><td><i>Revue de théologie et de philosophie</i></td></tr>
<tr><td><i>RTR</i></td><td><i>Reformed Theological Review</i></td></tr>
<tr><td>SacPag</td><td>Sacra pagina</td></tr>
<tr><td><i>SBFLA</i></td><td><i>Studii biblici Franciscani liber annuus</i></td></tr>
<tr><td>SBLDS</td><td>SBL Dissertation Series</td></tr>
<tr><td>SBLEJL</td><td>SBL Early Judaism and Its Literature</td></tr>
<tr><td>SBLMS</td><td>SBL Monograph Series</td></tr>
<tr><td>SBLRBS</td><td>SBL Resources for Biblical Study</td></tr>
<tr><td>SBLSBS</td><td>SBL Sources for Biblical Study</td></tr>
<tr><td>SBLSCS</td><td>SBL Septuagint and Cognate Studies</td></tr>
<tr><td>SBLSP</td><td>SBL Seminar Papers</td></tr>
<tr><td>SBLSS</td><td>SBL Symposium Series</td></tr>
<tr><td>SBT</td><td>Studies in Biblical Theology</td></tr>
<tr><td><i>ScEs</i></td><td><i>Science et esprit</i></td></tr>
<tr><td>SD</td><td>Studies and Documents</td></tr>
<tr><td><i>Sem</i></td><td><i>Semitica</i></td></tr>
<tr><td><i>SIG</i></td><td><i>Sylloge Inscriptionum Graecarum</i></td></tr>
<tr><td>SJLA</td><td>Studies in Judaism in Late Antiquity</td></tr>
<tr><td><i>SJT</i></td><td><i>Scottish Journal of Theology</i></td></tr>
<tr><td>SNT</td><td>Studien zum Neuen Testament</td></tr>
<tr><td>SNTSMS</td><td>Society for New Testament Studies Monograph Series</td></tr>
<tr><td>SO</td><td>Symbolae osloenses</td></tr>
<tr><td>SOTSMS</td><td>Society for Old Testament Study Monograph Series</td></tr>
<tr><td>SPB</td><td>Studia postbiblica</td></tr>
<tr><td>SPS</td><td>Salzburger patristische Studien</td></tr>
<tr><td><i>ST</i></td><td><i>Studia theologica</i></td></tr>
<tr><td>StudBib</td><td>Studia Biblica</td></tr>
<tr><td>SUNT</td><td>Studien zur Umwelt des Neuen Testaments</td></tr>
<tr><td>SVTP</td><td>Studia in Veteris Testamenti pseudepigrapha</td></tr>
<tr><td>TBu</td><td>Theologische Bücherei</td></tr>
<tr><td><i>TCGNT</i></td><td>B. M. Metzger, <i>A Textual Commentary on the Greek New Testament</i></td></tr>
<tr><td><i>TDNT</i></td><td>G. Kittel and G. Friedrich (eds.), <i>Theological Dictionary of the New Testament</i></td></tr>
<tr><td><i>TLNT</i></td><td><i>Theological Lexicon of the New Testament</i></td></tr>
<tr><td>TNTC</td><td>Tyndale New Testament Commentaries</td></tr>
<tr><td>TOTC</td><td>Tyndale Old Testament Commentaries</td></tr>
<tr><td><i>TS</i></td><td><i>Theological Studies</i></td></tr>
<tr><td><i>TTZ</i></td><td><i>Trierer theologische Zeitschrift</i></td></tr>
<tr><td>TU</td><td>Texte und Untersuchungen</td></tr>
<tr><td><i>TynBul</i></td><td><i>Tyndale Bulletin</i></td></tr>
<tr><td><i>UF</i></td><td><i>Ugarit-Forschungen</i></td></tr>
<tr><td><i>USQR</i></td><td><i>Union Seminary Quarterly Review</i></td></tr>
<tr><td><i>VC</i></td><td><i>Vigiliae christianae</i></td></tr>
<tr><td><i>VT</i></td><td><i>Vetus Testamentum</i></td></tr>
<tr><td>VTSup</td><td>Vetus Testamentum, Supplements</td></tr>
<tr><td>WA</td><td>M. Luther, Kristische Gesamtausgabe (= “Weimar” edition)</td></tr>
<tr><td>WBC</td><td>Word Biblical Commentary</td></tr>
<tr><td>WMANT</td><td>Wissenschaftliche Monographien zum Alten und Neuen Testament</td></tr>
<tr><td><i>WTJ</i></td><td><i>Westminster Theological Journal</i></td></tr>
<tr><td>WUNT</td><td>Wissenschaftliche Untersuchungen zum Neuen Testament</td></tr>
<tr><td><i>WWSup</i></td><td><i>Word and World Supplement</i></td></tr>
<tr><td><i>ZAW</i></td><td><i>Zeitschrift für die alttestamentliche Wissenschaft</i></td></tr>
<tr><td>ZBKNT</td><td>Zürcher Bibelkommentare, Neuen Testament</td></tr>
<tr><td><i>ZNW</i></td><td><i>Zeitschrift für die neutestamentliche Wissenschaft</i></td></tr>
<tr><td><i>ZTK</i></td><td><i>Zeitschrift für Theologie und Kirche</i></td></tr>
</tbody></table>
<p class="H1">GENERAL</p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr><td><span class="small">AD</span></td><td><i>anno Domini</i>, in the year of our Lord</td></tr>
<tr><td>Aram.</td><td>Aramaic</td></tr>
<tr><td>b.</td><td>born</td></tr>
<tr><td><i>b.</i></td><td>Babylonian Talmud</td></tr>
<tr><td><span class="small">BC</span></td><td>before Christ</td></tr>
<tr><td>c.</td><td><i>circa</i>, around</td></tr>
<tr><td>cent.</td><td>century</td></tr>
<tr><td>cf.</td><td><i>confer</i>, compare</td></tr>
<tr><td>ch(s).</td><td>chapter(s)</td></tr>
<tr><td>col.</td><td>column</td></tr>
<tr><td>d.</td><td>died</td></tr>
<tr><td>diss.</td><td>dissertation</td></tr>
<tr><td>DSS</td><td>Dead Sea Scrolls</td></tr>
<tr><td>ed.</td><td>editor, edition</td></tr>
<tr><td>e.g.</td><td><i>exempli gratia</i>, for example</td></tr>
<tr><td>esp.</td><td>especially</td></tr>
<tr><td>ET</td><td>English Translation</td></tr>
<tr><td>etc.</td><td><i>et cetera</i>, and the others</td></tr>
<tr><td>frg.</td><td>fragment</td></tr>
<tr><td>Gk.</td><td>Greek</td></tr>
<tr><td>HB</td><td>Hebrew Bible</td></tr>
<tr><td>Heb.</td><td>Hebrew</td></tr>
<tr><td>i.e.</td><td><i>id est</i>, that is</td></tr>
<tr><td>km.</td><td>kilometer</td></tr>
<tr><td>lit.</td><td>literally</td></tr>
<tr><td>LXX</td><td>Septuagint</td></tr>
<tr><td><i>m.</i></td><td>Mishnah</td></tr>
<tr><td>mg.</td><td>margin</td></tr>
<tr><td>mss.</td><td>manuscripts</td></tr>
<tr><td>Mt.</td><td>Mount</td></tr>
<tr><td>MT</td><td>Masoretic Text</td></tr>
<tr><td>NT</td><td>New Testament</td></tr>
<tr><td>OT</td><td>Old Testament</td></tr>
<tr><td><i>p.</i></td><td>Palestinian (Talmud)</td></tr>
<tr><td>par.</td><td>parallel</td></tr>
<tr><td>para(s).</td><td>paragraph(s)</td></tr>
<tr><td>pp.</td><td>pages (used only when necessary)</td></tr>
<tr><td>pt.</td><td>part</td></tr>
<tr><td>Q</td><td>Quelle (“sayings”) source for the Synoptic Gospels</td></tr>
<tr><td>repr.</td><td>reprinted</td></tr>
<tr><td>rev.</td><td>revised</td></tr>
<tr><td><i>t.</i></td><td>Tosefta</td></tr>
<tr><td>trans.</td><td>translated by</td></tr>
<tr><td><a id="page_ix">v. (vv.)</a></td><td>verse, verses</td></tr>
<tr><td>Vg</td><td>Vulgate</td></tr>
<tr><td>vs.</td><td>versus</td></tr>
</tbody></table>
<p class="H1">BIBLICAL BOOKS (WITH THE APOCRYPHA)</p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr><td>Gen</td><td>Genesis</td></tr>
<tr><td>Exod</td><td>Exodus</td></tr>
<tr><td>Lev</td><td>Leviticus</td></tr>
<tr><td>Num</td><td>Numbers</td></tr>
<tr><td>Deut</td><td>Deuteronomy</td></tr>
<tr><td>Josh</td><td>Joshua</td></tr>
<tr><td>Judg</td><td>Judges</td></tr>
<tr><td>1-2 Sam</td><td>1-2 Samuel</td></tr>
<tr><td>1-2 Kgs</td><td>1-2 Kings</td></tr>
<tr><td>Isa</td><td>Isaiah</td></tr>
<tr><td>Jer</td><td>Jeremiah</td></tr>
<tr><td>Ezek</td><td>Ezekiel</td></tr>
<tr><td>Hos</td><td>Hosea</td></tr>
<tr><td>Joel</td><td>Joel</td></tr>
<tr><td>Amos</td><td>Amos</td></tr>
<tr><td>Obad</td><td>Obadiah</td></tr>
<tr><td>Jonah</td><td>Jonah</td></tr>
<tr><td>Mic</td><td>Micah</td></tr>
<tr><td>Nah</td><td>Nahum</td></tr>
<tr><td>Hab</td><td>Habakkuk</td></tr>
<tr><td>Zeph</td><td>Zephaniah</td></tr>
<tr><td>Hag</td><td>Haggai</td></tr>
<tr><td>Zech</td><td>Zechariah</td></tr>
<tr><td>Mal</td><td>Malachi</td></tr>
<tr><td>Ps (<i>pl.:</i> Pss)</td><td>Psalm(s)</td></tr>
<tr><td>Job</td><td>Job</td></tr>
<tr><td>Prov</td><td>Proverbs</td></tr>
<tr><td>Ruth</td><td>Ruth</td></tr>
<tr><td>Cant</td><td>Canticles</td></tr>
<tr><td>Eccl (<i>or</i> Qoh)</td><td>Ecclesiastes (<i>or</i> Qoheleth)</td></tr>
<tr><td>Lam</td><td>Lamentations</td></tr>
<tr><td>Esth</td><td>Esther</td></tr>
<tr><td>Dan</td><td>Daniel</td></tr>
<tr><td>Ezra</td><td>Ezra</td></tr>
<tr><td>Neh</td><td>Nehemiah</td></tr>
<tr><td>1-2 Chr</td><td>1-2 Chronicles</td></tr>
<tr><td>1-2-3-4 Kgdms</td><td>1-2-3-4 Kingdoms</td></tr>
<tr><td>Add Esth</td><td>Additions to Esther</td></tr>
<tr><td>Bar</td><td>Baruch</td></tr>
<tr><td>Bel</td><td>Bel and the Dragon</td></tr>
<tr><td>1-2 Esdr</td><td>1-2 Esdras</td></tr>
<tr><td>4 Ezra</td><td>4 Ezra</td></tr>
<tr><td>Jdt</td><td>Judith</td></tr>
<tr><td>Ep Jer</td><td>Epistle of Jeremiah</td></tr>
<tr><td>1-2-3-4 Macc</td><td>1-2-3-4 Maccabees</td></tr>
<tr><td>Pr Azar</td><td>Prayer of Azariah</td></tr>
<tr><td>Pr Man</td><td>Prayer of Manasseh</td></tr>
<tr><td>Sir</td><td>Sirach</td></tr>
<tr><td>Sus</td><td>Susanna</td></tr>
<tr><td>Tob</td><td>Tobit</td></tr>
<tr><td>Wis</td><td>Wisdom of Solomon</td></tr>
<tr><td>Matt</td><td>Matthew</td></tr>
<tr><td>Mark</td><td>Mark</td></tr>
<tr><td>Luke</td><td>Luke</td></tr>
<tr><td>John</td><td>John</td></tr>
<tr><td>Acts</td><td>Acts</td></tr>
<tr><td>Rom</td><td>Romans</td></tr>
<tr><td>1-2 Cor</td><td>1-2 Corinthians</td></tr>
<tr><td>Gal</td><td>Galatians</td></tr>
<tr><td>Eph</td><td>Ephesians</td></tr>
<tr><td>Phil</td><td>Philippians</td></tr>
<tr><td>Col</td><td>Colossians</td></tr>
<tr><td>1-2 Thess</td><td>1-2 Thessalonians</td></tr>
<tr><td>1-2 Tim</td><td>1-2 Timothy</td></tr>
<tr><td>Titus</td><td>Titus</td></tr>
<tr><td>Phlm</td><td>Philemon</td></tr>
<tr><td>Heb</td><td>Hebrews</td></tr>
<tr><td>Jas</td><td>James</td></tr>
<tr><td>1-2 Pet</td><td>1-2 Peter</td></tr>
<tr><td>1-2-3 John</td><td>1-2-3 John</td></tr>
<tr><td>Jude</td><td>Jude</td></tr>
<tr><td>Rev</td><td>Revelation</td></tr>
</tbody></table>
<p class="H1">ANCIENT WORKS</p>
<p class="H2">Pseudepigraphical Books</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td><i>Apoc. Abr.</i></td><td><i>Apocalypse of Abraham</i></td></tr>
<tr><td><i>2-3 Apoc. Bar.</i></td><td>Syrian, Greek <i>Apocalypse of Baruch</i></td></tr>
<tr><td><i>Apoc. Elijah</i></td><td><i>Apocalypse of Elijah</i></td></tr>
<tr><td><i>Apoc. Mos.</i></td><td><i>Apocalypse of Moses</i></td></tr>
<tr><td><i>Apoc. Zeph.</i></td><td><i>Apocalypse of Zephaniah</i></td></tr>
<tr><td><i>As. Mos.</i></td><td><i>Assumption of Moses</i></td></tr>
<tr><td><i>Asc. Isa.</i></td><td><i>Ascension of Isaiah</i></td></tr>
<tr><td><i>1-2-3 Enoch</i></td><td>Ethiopic, Slavonic, Hebrew Enoch</td></tr>
<tr><td><i>Ep. Arist.</i></td><td><i>Epistle of Aristeas</i></td></tr>
<tr><td><i>Jos. Asen.</i></td><td><i>Joseph and Aseneth</i></td></tr>
<tr><td><i>Jub.</i></td><td><i>Jubilees</i></td></tr>
<tr><td><i>Mart. Isa.</i></td><td><i>Martyrdom of Isaiah</i></td></tr>
<tr><td><i>Para. Jer.</i></td><td><i>Paraleipomena Jeremiah</i></td></tr>
<tr><td><i>Pss. Sol.</i></td><td><i>Psalms of Solomon</i></td></tr>
<tr><td><i>Sib. Or.</i></td><td><i>Sibylline Oracles</i></td></tr>
<tr><td><i>T. Job</i></td><td><i>Testament of Job</i></td></tr>
<tr><td><i>T. Moses</i></td><td><i>Testament of Moses</i></td></tr>
<tr><td><i>T. 12 Patr.</i></td><td><i>Testaments of the Twelve Patriarchs</i></td></tr>
<tr><td><i>T. Ash.</i></td><td><i>Testament of Asher</i></td></tr>
<tr><td><i>T. Benj.</i></td><td><i>Testament of Benjamin</i></td></tr>
<tr><td><i>T. Dan</i></td><td><i>Testament of Dan</i></td></tr>
<tr><td><i>T. Iss.</i></td><td><i>Testament of Issachar</i></td></tr>
<tr><td><i>T. Jos.</i></td><td><i>Testament of Joseph</i></td></tr>
<tr><td><i>T. Jud.</i></td><td><i>Testament of Judah</i></td></tr>
<tr><td><i>T. Levi</i></td><td><i>Testament of Levi</i></td></tr>
<tr><td><i>T. Naph.</i></td><td><i>Testament of Naphtali</i></td></tr>
<tr><td><i>T. Reub.</i></td><td><i>Testament of Reuben</i></td></tr>
<tr><td><i>T. Sol.</i></td><td><i>Testament of Solomon</i></td></tr>
</tbody></table>
<p class="H2">Early Patristic Books</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td><i>Apost. Const.</i></td><td><i>Apostolic Constitutions</i></td></tr>
<tr><td><i>Barn.</i></td><td><i>Barnabas</i></td></tr>
<tr><td>Clem.</td><td>Clement</td></tr>
<tr><td class="td1"><i>Strom.</i></td><td class="td1"><i>Stromateis</i></td></tr>
<tr><td><i>1-2 Clem.</i></td><td><i>1-2 Clement</i></td></tr>
<tr><td><i>Did.</i></td><td><i>Didache</i></td></tr>
<tr><td><i>Diogn.</i></td><td><i>Diognetus</i></td></tr>
<tr><td><a id="page_x"><i>Ep. ad Flor.</i></a></td><td><i>Letter to Florinus</i></td></tr>
<tr><td>Eusebius</td><td>Eusebius</td></tr>
<tr><td class="td1"><i>Hist. Eccl.</i></td><td class="td2"><i>Historia ecclesiastica</i></td></tr>
<tr><td class="td1"><i>Praep. Evang.</i></td><td class="td2"><i>Praeparatio evangelica</i></td></tr>
<tr><td><i>Gos. Naz.</i></td><td><i>Gospel of the Nazarenes</i></td></tr>
<tr><td>Herm.</td><td>Hermas</td></tr>
<tr><td class="td1"><i>Sim.</i></td><td class="td2"><i>Similitude(s)</i></td></tr>
<tr><td>Ign.</td><td>Ignatius</td></tr>
<tr><td class="td1"><i>Eph.</i></td><td class="td2"><i>Letter to the Ephesians</i></td></tr>
<tr><td class="td1"><i>Magn.</i></td><td class="td2"><i>Letter to the Magnesians</i></td></tr>
<tr><td class="td1"><i>Phld.</i></td><td class="td2"><i>Letter to the Philadelphians</i></td></tr>
<tr><td class="td1"><i>Pol.</i></td><td class="td2"><i>Letter to Polycarp</i></td></tr>
<tr><td class="td1"><i>Trall.</i></td><td class="td2"><i>Letter to the Trallians</i></td></tr>
<tr><td>Iren.</td><td>Irenaeus</td></tr>
<tr><td class="td1"><i>Adv. Haer.</i></td><td class="td2"><i>Adversus haereses</i></td></tr>
<tr><td>Justin</td><td>Justin</td></tr>
<tr><td class="td1"><i>Dial. Tryph.</i></td><td class="td2"><i>Dialogus contra Tryphonem</i></td></tr>
<tr><td class="td1"><i>1 Apol.</i></td><td class="td2"><i>First Apology</i></td></tr>
<tr><td>Origen</td><td>Origen</td></tr>
<tr><td class="td1"><i>In Jerem. hom. Lat.</i></td><td class="td2"><i>Latinae homiliae in Jeremiam</i></td></tr>
<tr><td>Pol.</td><td>Polycarp</td></tr>
<tr><td class="td1"><i>Phil.</i></td><td class="td2"><i>Letter to the Philippians</i></td></tr>
<tr><td><i>Ps.-Clem.</i></td><td><i>Pseudo-Clementine Recognitions</i></td></tr>
<tr><td>Ps.-Philo</td><td>Pseudo-Philo</td></tr>
<tr><td class="td1"><i>Bib. Ant.</i></td><td class="td2"><i>Biblical Antiquities</i></td></tr>
<tr><td>Tertullian</td><td>Tertullian</td></tr>
<tr><td class="td1"><i>Adv. Marc.</i></td><td class="td2"><i>Adversus Marcionum</i></td></tr>
</tbody></table>
<p class="H2">Dead Sea Scrolls and Related Texts</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td>CD</td><td>Cairo (Genizah text of the) <i>Damascus (Document)</i></td></tr>
<tr><td>1Q, 2Q, 3Q, etc.</td><td>Numbered caves of Qumran, yielding written material; followed by abbreviation of biblical or apocryphal book</td></tr>
<tr><td>1QapGen</td><td><i>Genesis Apocryphon</i> of Qumran Cave 1</td></tr>
<tr><td>1QH</td><td><i>Hodayot (Thanksgiving Hymns)</i> from Qumran Cave 1</td></tr>
<tr><td>1QIsa<sup>﻿a</sup></td><td>First copy of Isaiah from Qumran Cave 1</td></tr>
<tr><td>1QIsa<sup>﻿b</sup></td><td>Second copy of Isaiah from Qumran Cave 1</td></tr>
<tr><td>1QpHab</td><td><i>Pesher on Habakkuk</i> from Qumran Cave 1</td></tr>
<tr><td>1QM</td><td><i><span class="charSI">Milḥamah</span> (War Scroll)</i></td></tr>
<tr><td>1QS</td><td><i>Serek hayyahad (Rule of the Community, Manual of Discipline)</i></td></tr>
<tr><td>1QSa</td><td>Appendix A <i>(Rule of the Congregation)</i> to 1QS</td></tr>
<tr><td>4QDibHam</td><td><i>Words of the Luminaries</i> from Qumran Cave 4</td></tr>
<tr><td>4QFlor</td><td><i>Florilegium</i> (or <i>Eschatological Midrashim</i>) from Qumran Cave 4</td></tr>
<tr><td>4QMMT</td><td><i><span class="charSI">Miqṣat Maʿase ha-Torah</span></i> from Qumran Cave 4</td></tr>
<tr><td>4QpHab</td><td><i>Pesher on Habakkuk</i> from Qumran Cave 4</td></tr>
<tr><td>4QPrNab</td><td><i>Prayer of Nabonidus</i> from Qumran Cave 4</td></tr>
<tr><td>4QpsDan ar<sup>﻿a</sup></td><td><i>Apocryphon of Daniel</i></td></tr>
<tr><td>11QMelch</td><td><i>Melchizedek</i> text from Qumran Cave 11</td></tr>
<tr><td>11QTemple</td><td><i>Temple Scroll</i> from Qumran Cave 11</td></tr>
<tr><td>11QPs<sup>﻿a</sup></td><td><i>Psalms Scroll</i> from Qumran Cave 11</td></tr>
</tbody></table>
<p class="H2">Targumic Material</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td><i>Tg. Neb.</i></td><td><i>Targum of the Prophets</i></td></tr>
<tr><td><i>Tg. Neof.</i></td><td><i>Targum</i> Neofiti</td></tr>
<tr><td><i>Tg. Isa</i></td><td><i>Targum of Isaiah</i></td></tr>
<tr><td><i>Tg. Hos</i></td><td><i>Targum of Hosea</i></td></tr>
<tr><td><i>Tg. Ps.-Jon.</i></td><td><i>Targum of Pseudo-Jonathan</i></td></tr>
</tbody></table>
<p class="H2">Orders and Tractates in Mishnaic and Related Literature</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td><i><span class="charSI">ʾ</span>Abot</i></td><td><i><span class="charSI">ʾ</span>Abot</i></td></tr>
<tr><td><i>B. Bat.</i></td><td><i>Baba Batra</i></td></tr>
<tr><td><i>Ber.</i></td><td><i>Berakhot</i></td></tr>
<tr><td><i><span class="charSI">ʿ</span>Ed.</i></td><td><i><span class="charSI">ʿ</span>Eduyyot</i></td></tr>
<tr><td><i><span class="charSI">ʿ</span>Erub.</i></td><td><i><span class="charSI">ʿ</span>Erubin</i></td></tr>
<tr><td><i><span class="charSI">Giṭ.</span></i></td><td><i><span class="charSI">Giṭṭin</span></i></td></tr>
<tr><td><i><span class="charSI">Ḥag</span>.</i></td><td><i><span class="charSI">Ḥagigah</span></i></td></tr>
<tr><td><i>Hor.</i></td><td><i>Horayot</i></td></tr>
<tr><td><i>Kelim</i></td><td><i>Kelim</i></td></tr>
<tr><td><i>Ker.</i></td><td><i>Keritot</i></td></tr>
<tr><td><i>Ma<span class="charSI">ʿ</span>as.</i></td><td><i>Ma<span class="charSI">ʿ</span>aserot</i></td></tr>
<tr><td><i>Mak.</i></td><td><i>Makkot</i></td></tr>
<tr><td><i>Meg.</i></td><td><i>Megillah</i></td></tr>
<tr><td><i>Ned.</i></td><td><i>Nedarim</i></td></tr>
<tr><td><i>Nid.</i></td><td><i>Niddah</i></td></tr>
<tr><td><i><span class="charSI">Pesaḥ.</span></i></td><td><i><span class="charSI">Pesaḥim</span></i></td></tr>
<tr><td><i>Sanh.</i></td><td><i>Sanhedrin</i></td></tr>
<tr><td><i>Shab.</i></td><td><i>Shabbat</i></td></tr>
<tr><td><i>Sheqal.</i></td><td><i>Sheqalim</i></td></tr>
<tr><td><i><span class="charSI">oṭa</span></i></td><td><i><span class="charSI">Soṭa</span></i></td></tr>
<tr><td><i>Suk.</i></td><td><i>Sukkah</i></td></tr>
<tr><td><i>Ta<span class="charSI">ʿ</span>an</i></td><td><i>Ta<span class="charSI">ʿ</span>anit</i></td></tr>
<tr><td><i><span class="charSI">Ṭohar</span>.</i></td><td><i><span class="charSI">Ṭoharot</span></i></td></tr>
<tr><td><i>Yoma</i></td><td><i>Yoma</i></td></tr>
</tbody></table>
<p class="H2">Other Rabbinic Works</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td><i><span class="charSI">ʾ</span>Abot R. Nat.</i></td><td><i><span class="charSI">ʾ</span>Abot de-Rabbi Nathan</i></td></tr>
<tr><td><i>Mek.</i></td><td><i>Mekilta</i></td></tr>
<tr><td><i>Midr.</i></td><td><i>Midrash</i></td></tr>
<tr><td><i>Pesiq. R.</i></td><td><i>Pesiqta Rabbati</i></td></tr>
<tr><td><i>Pesiq. Rab. Kah.</i></td><td><i>Pesiqta de Rab Kahana</i></td></tr>
<tr><td><i>Pirqe R. El.</i></td><td><i>Pirqe Rabbi Eliezer</i></td></tr>
<tr><td><i>Rab.</i></td><td><i>Rabbah</i></td></tr>
<tr><td><i>Sipre</i></td><td><i>Sipre</i></td></tr>
</tbody></table>
<p class="H2">Other Ancient Works</p>
<table cellpadding="0" cellspacing="0" class="abbre0">
<tbody><tr><td colspan="2">Aeschylus</td></tr>
<tr><td class="td1"><i>Agam.</i></td><td><i>Agamemnon</i></td></tr>
<tr><td colspan="2">Aristotle</td></tr>
<tr><td class="td1"><i>Nic. Eth.</i></td><td><i>Nicomachean Ethics</i></td></tr>
<tr><td class="td1"><i>Rhet.</i></td><td><i>On Rhetoric</i></td></tr>
<tr><td colspan="2">Cicero</td></tr>
<tr><td class="td1"><i>Tusc. disp.</i></td><td><i>Tusculanae disputationes</i></td></tr>
<tr><td colspan="2">Demosthenes</td></tr>
<tr><td class="td1"><i>Orat.</i></td><td><i>Orations</i></td></tr>
<tr><td colspan="2">Dio Chrysostom</td></tr>
<tr><td class="td1"><i>Ep.</i></td><td><i>Epistles</i></td></tr>
<tr><td class="td1"><i>Orat.</i></td><td><i>Orations</i></td></tr>
<tr><td colspan="2">Dionysius of Halicarnassus</td></tr>
<tr><td class="td1"><i>Rom. Ant.</i></td><td><i>Antiquitates Romanae</i></td></tr>
<tr><td colspan="2">Epictetus</td></tr>
<tr><td class="td1"><i>Disc.</i></td><td><i>Discourses</i></td></tr>
<tr><td class="td1"><a id="page_xi"><i>Diss.</i></a></td><td><i>Dissertations</i></td></tr>
<tr><td colspan="2">Epimenides</td></tr>
<tr><td class="td1"><i>Strom.</i></td><td><i>Stromateis</i></td></tr>
<tr><td colspan="2">Herodotus</td></tr>
<tr><td class="td1"><i>Hist.</i></td><td><i>Histories</i></td></tr>
<tr><td colspan="2">Josephus</td></tr>
<tr><td class="td1"><i>Ag. Ap.</i></td><td><i>Against Apion</i></td></tr>
<tr><td class="td1"><i>Ant.</i></td><td><i>Antiquities</i></td></tr>
<tr><td class="td1"><i>J.W.</i></td><td><i>Jewish Wars</i></td></tr>
<tr><td class="td1"><i>Life</i></td><td><i>Life of Flavius Josephus</i></td></tr>
<tr><td colspan="2">Juvenal</td></tr>
<tr><td class="td1"><i>Sat.</i></td><td><i>Satires</i></td></tr>
<tr><td colspan="2">Livy</td></tr>
<tr><td class="td1"><i>Hist.</i></td><td><i>Histories</i></td></tr>
<tr><td colspan="2">Lucian</td></tr>
<tr><td class="td1"><i>Peregr.</i></td><td><i>The Passing of Peregrinus</i></td></tr>
<tr><td colspan="2">Musonius</td></tr>
<tr><td class="td1"><i>Orat.</i></td><td><i>Orations</i></td></tr>
<tr><td colspan="2">Philo</td></tr>
<tr><td class="td1"><i>Abr.</i></td><td><i>De Abrahamo</i></td></tr>
<tr><td class="td1"><i>Agr.</i></td><td><i>De agricultura</i></td></tr>
<tr><td class="td1"><i>Cher.</i></td><td><i>De cherubim</i></td></tr>
<tr><td class="td1"><i>Conf. ling.</i></td><td><i>De confusione linguarum</i></td></tr>
<tr><td class="td1"><i>Congr.</i></td><td><i>De congressu eruditionis gratia</i></td></tr>
<tr><td class="td1"><i>Decal.</i></td><td><i>De decalogo</i></td></tr>
<tr><td class="td1"><i>Det. pot. ins.</i></td><td><i>Quod deterius potiori insidiari soleat</i></td></tr>
<tr><td class="td1"><i>Ebr.</i></td><td><i>De ebrietate</i></td></tr>
<tr><td class="td1"><i>Flacc.</i></td><td><i>In Flaccum</i></td></tr>
<tr><td class="td1"><i>Fug.</i></td><td><i>De fuga et inventione</i></td></tr>
<tr><td class="td1"><i>Gig.</i></td><td><i>De gigantibus</i></td></tr>
<tr><td class="td1"><i>Her.</i></td><td><i>Quis rerum divinarum heres sit</i></td></tr>
<tr><td class="td1"><i>Hypoth.</i></td><td><i>Hypothetica</i></td></tr>
<tr><td class="td1"><i>Leg. all.</i></td><td><i>Legum allegoriae</i></td></tr>
<tr><td class="td1"><i>Legat.</i></td><td><i>Legatio ad Gaium</i></td></tr>
<tr><td class="td1"><i>Migr. Abr.</i></td><td><i>De migratione Abrahami</i></td></tr>
<tr><td class="td1"><i>Mut. nom.</i></td><td><i>De mutatione nominum</i></td></tr>
<tr><td class="td1"><i>Opif.</i></td><td><i>De opificio mundi</i></td></tr>
<tr><td class="td1"><i>Post.</i></td><td><i>De posteritate Caini</i></td></tr>
<tr><td class="td1"><i>Prob.</i></td><td><i>Quod omnis probus liber sit</i></td></tr>
<tr><td class="td1"><i>Quaest. Exod.</i></td><td><i>Quaestiones et solutiones in Exodum</i></td></tr>
<tr><td class="td1"><i>Quaest Gen.</i></td><td><i>Quaestiones et solutiones in Genesim</i></td></tr>
<tr><td class="td1"><i>Sacr.</i></td><td><i>De sacrificiis Abelis et Caini</i></td></tr>
<tr><td class="td1"><i>Somn.</i></td><td><i>De somniis</i></td></tr>
<tr><td class="td1"><i>Spec. leg.</i></td><td><i>De specialibus legibus</i></td></tr>
<tr><td class="td1"><i>Virt.</i></td><td><i>De virtutibus</i></td></tr>
<tr><td class="td1"><i>Vit. Mos.</i></td><td><i>De vita Mosis</i></td></tr>
<tr><td colspan="2">Philostratus</td></tr>
<tr><td class="td1"><i>Vita Ap.</i></td><td><i>Vita Apollonius</i></td></tr>
<tr><td colspan="2">Plato</td></tr>
<tr><td class="td1"><i>Apol.</i></td><td><i>Apology</i></td></tr>
<tr><td class="td1"><i>Gorg.</i></td><td><i>Gorgias</i></td></tr>
<tr><td class="td1"><i>Rep.</i></td><td><i>Republic</i></td></tr>
<tr><td class="td1"><i>Sym.</i></td><td><i>Symposium</i></td></tr>
<tr><td colspan="2">Pliny</td></tr>
<tr><td class="td1"><i>Ep.</i></td><td><i>Epistles</i></td></tr>
<tr><td class="td1"><i>Nat. Hist.</i></td><td><i>Natural History</i></td></tr>
<tr><td colspan="2">Plutarch</td></tr>
<tr><td class="td1"><i>Mor.</i></td><td><i>Moralia</i></td></tr>
<tr><td colspan="2">Polybius</td></tr>
<tr><td class="td1"><i>Hist.</i></td><td><i>History</i></td></tr>
<tr><td colspan="2">Quintilian</td></tr>
<tr><td class="td1"><i>Inst.</i></td><td><i>Institutio oratoria</i></td></tr>
<tr><td class="td1"><i>Rhet. Her.</i></td><td><i>Rhetorica ad Herennium</i></td></tr>
<tr><td colspan="2">Seneca</td></tr>
<tr><td class="td1"><i>Benef.</i></td><td><i>De beneficiis</i></td></tr>
<tr><td class="td1"><i>Ep. Mor.</i></td><td><i>Epistulae morales</i></td></tr>
<tr><td colspan="2">Strabo</td></tr>
<tr><td class="td1"><i>Geog.</i></td><td><i>Geography</i></td></tr>
<tr><td colspan="2">Tacitus</td></tr>
<tr><td class="td1"><i>Ann.</i></td><td><i>Annales</i></td></tr>
<tr><td class="td1"><i>Hist.</i></td><td><i>Historiae</i></td></tr>
<tr><td colspan="2">Thucydides</td></tr>
<tr><td class="td1"><i>Hist.</i></td><td><i>Histories</i></td></tr>
<tr><td colspan="2">Xenophon</td></tr>
<tr><td class="td1"><i>Apol.</i></td><td><i>Apologia Socratis</i></td></tr>
<tr><td class="td1"><i>Cyr.</i></td><td><i>Cyropaedia</i></td></tr>
<tr><td class="td1"><i>Mem.</i></td><td><i>Memorabilia</i></td></tr>
<tr><td class="td1"><i>Symp.</i></td><td><i>Symposium</i></td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?24631ea1